export enum ConnectionTypes {
  Main = 'Main',
  Catalogs = 'Catalogs',
  Archiver = 'Archiver',
}
